export enum DurationUnit {
    MONTHS = 'MONTHS'
}
export enum MileageUnit {
    KILOMETERS = 'KILOMETERS',
    MILES = 'MILES'
}
export enum HeyCarCoreProduct {
    AUTOCREDIT = 'AUTOCREDIT',
    PRIVATELEASE = 'PRIVATELEASE'
}
export enum VehicleUsage {
    None = 'None',
    DemonstrationCar = 'DemonstrationCar',
    PlantCompanyCar = 'PlantCompanyCar',
    CompanyCar = 'CompanyCar',
    RentalCar = 'RentalCar',
    OneYearOldCar = 'OneYearOldCar',
    ExternalDealerDemonstrationCar = 'ExternalDealerDemonstrationCar',
    DrivingSchoolCar = 'DrivingSchoolCar',
    Taxi = 'Taxi',
    MajorCustomerTestCar = 'MajorCustomerTestCar',
    PersonEmployeeVWGroupLeasing = 'PersonEmployeeVWGroupLeasing',
    OneDayOldCar = 'OneDayOldCar',
    PromotionCar = 'PromotionCar',
    Euromobil = 'Euromobil'
}
export enum Taxation {
    STANDARD = 'StandardTaxation',
    DIFFERENTIAL = 'DifferentialTaxation'
}
export enum Brand {
    VW = 'vw',
    VWN = 'vwn',
    PORSCHE = 'porsche',
    DUTCHFINANCE = 'dutchfinance',
    AUTOCASH = 'autocash',
    AUDI = 'audi',
    SEAT = 'seat',
    SKODA = 'skoda',
    VWFS = 'vwfs',
    BENTLEY = 'bentley'
}
export enum VehicleModelDriveType {
    FRONT = 'FRONT',
    REAR = 'REAR',
    ALL_WHEEL = 'ALL_WHEEL',
    FOUR_BY_FOUR = 'FOUR_BY_FOUR'
}
export enum EnginePowerUnit {
    HORSEPOWER = 'HORSEPOWER',
    KILOWATT = 'KILOWATT'
}

export enum SaveCustomerDocumentsState {
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}

export enum DealerRole {
    PICKUP = 'PICKUP'
}